import { render, staticRenderFns } from "./AccountTopUps.vue?vue&type=template&id=665dac76&"
import script from "./AccountTopUps.vue?vue&type=script&lang=js&"
export * from "./AccountTopUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports